import React from "react";
import { useTranslate } from "ra-core";

export const useEnumSelectChoices = (enumObj, enumName, shouldTranslate = true) => {
	const translate = useTranslate();
	let getName = (key) => key;
	if (shouldTranslate) {
		getName = (key) => translate(`osfc.enums.${enumName}.${key}`);
	}
	const choices = React.useMemo(
		() =>
			Object.keys(enumObj).map((key) => ({
				id: enumObj[key],
				name: getName(key),
			})),
		[enumObj, enumName, shouldTranslate, translate]
	);
	return choices;
};
